import { MDCTabBar } from '@material/tab-bar'

export default {
  setup() {
    this.tabBar = new MDCTabBar(this.el)
  },
  destroy() {
    this.tabBar?.destroy()
    this.tabBar = null
  },
  mounted() {
    this.setup()

    this.handleEvent('disable_tabs', ({ ids }) => {
      let buttons = this.el.querySelectorAll('button.mdc-tab')

      buttons.forEach((button) => {
        if (ids.includes(button.id)) {
          button.setAttribute('disabled', 'disabled')
        } else {
          button.removeAttribute('disabled')
        }
      })
    })

    this.handleEvent('move_to_tab', ({ id }) => {
      let buttons = this.el.querySelectorAll('button.mdc-tab')

      buttons.forEach((button) => {
        if (id == button.id) {
          button.click()
        }
      })
    })
  },
  destroyed() {
    this.destroy()
  }
}
